import React from "react";
import { useSelector } from "react-redux";
import CasesTable from "./components/CasesTable";
import { GlobalContainer } from "../../common/components/Container";
import BannerTitle from "../../common/components/BannerTitle";
const Cases = () => {
  const user = useSelector((state) => state.user);
  return (
    <GlobalContainer theme="purple">
      <BannerTitle type="banner" theme="purple">
        Cases
      </BannerTitle>
      <CasesTable user={user} />
    </GlobalContainer>
  );
};

export default Cases;
